import axios from "src/lib/axios";
import { EmailMethodsMaster, EmailSettingsConfigResponse } from "./Types";
import AlertMessage from "src/components/ui-components/AlertMessage";

const API_URLS = {
  GET_EMAIL_METHODS_MASTER: `/EmailMethodsMaster/GetEmailMethodsMaster`,
  GET_EMAIL_SETTINGS: `/EmailSettings/GetEmailSettingsForConfig`,
  INSERT_UPDATE_EMAIL_SETTINGS: `/EmailSettings/InsertUpdateEmailSettingsForConfig`
};

export const GetEmailMethodsMaster = async (): Promise<any> => {
  try {
    const response = await axios.get<EmailMethodsMaster[]>(API_URLS.GET_EMAIL_METHODS_MASTER);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const GetEmailSettings = async (): Promise<any> => {
  try {
    const response = await axios.get<EmailSettingsConfigResponse[]>(API_URLS.GET_EMAIL_SETTINGS);
    return response?.data || {};
  } catch {
    return {};
  }
};

export const InsertUpdateEmailSettings = async (data): Promise<any> => {
  try {
    const res = await axios.post(API_URLS.INSERT_UPDATE_EMAIL_SETTINGS, data);
    AlertMessage({ type: 'success', msg: 'Email settings updated successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err?.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg?.errorMessage });
    });
    return false;
  }
};
